(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["outletlet-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-ol-variant]')) return;
    var option = event.target.options[event.target.selectedIndex];
    var root = event.target.closest('.ol-home');
    var price = root.querySelector('[data-ol-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    var stickyPrice = root.querySelector('[data-ol-sticky-price]');
    var stickyVariant = root.querySelector('[data-ol-sticky-variant]');
    if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    if (stickyVariant) stickyVariant.value = option.value;
  });
  function updateOutletletSticky() {
    document.querySelectorAll('[data-ol-sticky]').forEach(function(sticky) {
      sticky.hidden = window.scrollY < window.innerHeight * 2;
    });
  }
  window.addEventListener('scroll', updateOutletletSticky, { passive: true });
  window.addEventListener('resize', updateOutletletSticky);
  updateOutletletSticky();

  } catch(e) { console.error(e); }
})();
})();
